var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login-container"},[_c('Header',{attrs:{"showMenu":false}}),_c('LoginBox',{attrs:{"errorMsg":_vm.errorMsg},on:{"onSubmit":_vm.onSubmit}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }